import React, { createContext, useState, useEffect } from "react";
export const ShapeContext = createContext({});

const ShapeContextProvider = ({ children }) => {

  const [box1c, setBox1c] = useState(false);
  const [box2c, setBox2c] = useState(false);
  const [box3c, setBox3c] = useState(false);
  const [box4c, setBox4c] = useState(false);
  
  const [box1r, setBox1r] = useState(false);
  const [box2r, setBox2r] = useState(false);
  const [box3r, setBox3r] = useState(false);
  const [box4r, setBox4r] = useState(false);
  
  const [box1l, setBox1l] = useState(false);
  const [box2l, setBox2l] = useState(false);
  const [box3l, setBox3l] = useState(false);
  const [box4l, setBox4l] = useState(false);
  
  const [box1t, setBox1t] = useState(false);
  const [box2t, setBox2t] = useState(false);
  const [box3t, setBox3t] = useState(false);
  const [box4t, setBox4t] = useState(false);

  const [box1is, setBox1is] = useState(false);
  const [box2is, setBox2is] = useState(false);
  const [box3is, setBox3is] = useState(false);
  const [box4is, setBox4is] = useState(false);


return (
  <ShapeContext.Provider
  value={{
    box1c, setBox1c,
    box2c, setBox2c,
    box3c, setBox3c,
    box4c, setBox4c,
    box1r, setBox1r,
    box2r, setBox2r,
    box3r, setBox3r,
    box4r, setBox4r,
    box1l, setBox1l,
    box2l, setBox2l,
    box3l, setBox3l,
    box4l, setBox4l,
    box1t, setBox1t,
    box2t, setBox2t,
    box3t, setBox3t,
    box4t, setBox4t,
    box1is, setBox1is,
    box2is, setBox2is,
    box3is, setBox3is,
    box4is, setBox4is,
  }}
>
  {children}
</ShapeContext.Provider>
)

}


export default ShapeContextProvider;